import type { SessionPort, UserProfilePort } from '../domain/auth'

const makeUpdateUserProfile = (profile: UserProfilePort, session: SessionPort) =>
	async (name: string): Promise<void> => {
		const current = session.get()
		if (!current) return
		await profile.updateName(current.user.id, name)
		session.patchUser({ fullName: name })
	}

export { makeUpdateUserProfile }
